import { ArrowDownward } from "@material-symbols-svg/react";
import React from "react";

interface RangeBarProps {
  min: number;
  max: number;
  rangeStart: number;
  rangeEnd: number;
  value: number;
}

const RangeBar: React.FC<RangeBarProps> = ({
  min,
  max,
  rangeStart,
  rangeEnd,
  value,
}) => {
  // Definition rangeStart < min < max < rangeEnd

  // const min = 70;
  // const max = 140;
  // const rangeStart = 0;
  // const rangeEnd = 200;
  // const value = 150;

  // console.log("RangeBar");
  // console.log("Min:", min);
  // console.log("Max:", max);
  // console.log("RangeStart:", rangeStart);
  // console.log("RangeEnd:", rangeEnd);
  // console.log("Value:", value);

  return (
    <div className="mt-6 mb-2 w-full flex items-center justify-between gap-1">
      <Line
        start={rangeStart}
        end={min}
        value={value < min ? min : value}
        color="#D14B3B"
        showPointer={rangeStart <= value && value < min}
        style={{ width: "20%" }}
        position="left"
      />
      <Line
        start={min}
        end={max}
        value={value}
        color="#4BA05E"
        showRanges={true}
        showPointer={min <= value && value <= max}
        style={{ width: "60%" }}
        position="center"
      />
      <Line
        start={max}
        end={rangeEnd}
        value={value > rangeEnd ? rangeEnd : value}
        color="#D14B3B"
        showPointer={max < value && value <= rangeEnd}
        style={{ width: "20%" }}
        position="right"
      />
    </div>
  );
};

export default RangeBar;

const Line: React.FC<any> = ({
  start,
  end,
  value,
  color,
  showRanges = false,
  showPointer = false,
  style = {},
  position = "center",
}) => {
  const pointerPosition = (value - start) / (end - start);
  const pointerPositionPercentage = pointerPosition * 100;
  const pointerPositionPercentageClamped = Math.min(
    Math.max(pointerPositionPercentage, 0),
    position === "center" ? 80 : 60
  );

  return (
    <div
      className="h-1 w-full relative"
      style={{ backgroundColor: color, ...style }}
    >
      {showRanges && (
        <>
          <div className="absolute -bottom-5 left-0 text-xs text-[#181C23]">
            {start}
          </div>
          <div className="absolute -bottom-5 right-0 text-xs text-[#181C23]">
            {end}
          </div>
        </>
      )}
      {showPointer && (
        <div
          className="absolute bottom-2 left-0 text-xs text-[#181C23]"
          // style={{ left: `${value * 100}%` }}
          style={{
            left: `${pointerPositionPercentageClamped}%`,
            // transform: `translateX(${pointerPositionPercentageClamped}%)`,
          }}
        >
          {/* <img src={PointerIcon} alt={value} /> */}
          <ArrowDownward className="w-4 h-4 text-[#181C23]" />
        </div>
      )}
    </div>
  );
};
